import React from "react";
import { NavLink } from "react-router-dom";
import "../assets/styles/components/MenuInternal.sass";

const MenuManizales = () => (
  <div className="row MenuInternal -manizales">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/acerca-de-la-carrera">SERIES MANIZALES RESUMEN</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink id="que-incluye" to="/manizales/precios-que-incluye">
                PRECIOS Y QUÉ INCLUYE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/carrera-manizales">RUTAS</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/categorias">CATEGORÍAS</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/premiacion-y-reglamento">PREMIACIÓN Y REGLAMENTO</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/patrocinio-expo">PATROCINIO Y EXPO</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/galeria">GALERÍA</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/manizales/resultados">RESULTADOS</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default MenuManizales;
